import { SegmentType } from 'modules/Search/constants';
import {
  Side as TvSide,
} from '../TradingChart/components/TradingView/sources/charting_library';

// !!! Use OrderSide instead of Sides. We are going to remove Sides later
export enum Sides {
  B = 'Buy',
  S = 'Sell',
}

export enum OrderSide {
  Buy = 'B',
  Sell = 'S',
}

export const SideColors = {
  [OrderSide.Sell]: 'text.negative',
  [OrderSide.Buy]: 'text.positive',
};

export const ReadableOrderSide: Record<OrderSide, string> = {
  [OrderSide.Buy]: 'Buy',
  [OrderSide.Sell]: 'Sell',
};

export const SIDES: Record<TvSide, OrderSide> = {
  [TvSide.Buy]: OrderSide.Buy,
  [TvSide.Sell]: OrderSide.Sell,
};

export enum OrderTypes {
  L = 'Limit',
  M = 'Market',
  SL = 'SL Limit',
  'SL-M' = 'SL Market',
}

// Use this type instead of above one
export enum OrderType {
  Limit = 'L',
  Market = 'M',
  StopLimit = 'SL',
  StopLimitMarket = 'SL-M',
}

export enum OrderStatuses {
  O = 'Open',
  TP = 'Trigger Pending',
  COM = 'Complete',
  CAN = 'Cancelled',
  R = 'Failed',
  P = 'Pending',
  L = 'Lapsed',
  POR = 'Put order request received',
  AMO = 'AMO',
  INACTIVE = 'Inactive',
  SCHEDULED = 'Scheduled',
  TRIGGERED = 'TRIGGERED',
}

export enum OrderValidities {
  I = 'I',
  D = 'D',
}

// Todo: use only 1 type in future - Products or PlaceOrderProduct
export enum Products {
  I = 'Intraday',
  D = 'Delivery',
  CO = 'CO',
  OCO = 'OCO',
  MTF = 'MTF',
  MTFS = 'MTFS',
  STG = 'STG',
}

export enum PlaceOrderProduct {
  Intraday = 'I',
  Delivery = 'D',
  CO = 'CO',
  OCO = 'OCO',
  MTF = 'MTF',
  MTFS = 'MTFS',
  STG = 'STG',
}

export type OrderDuration = {
  type: OrderValidity;
};

export type CommonOrderDuration = {
  type: CommonOrderValidity
}

enum TvOrderType {
  'L' = 1,
  'M' = 2,
  'SLM' = 3,
  'SL' = 4,
}

export const ORDER_TYPE: Record<TvOrderType, OrderEntryOrderType> = {
  [TvOrderType.M]: 'M',
  [TvOrderType.SL]: 'SL',
  [TvOrderType.SLM]: 'SL-M',
  [TvOrderType.L]: 'L',
};

export const COMMON_ORDER_TYPE: Record<TvOrderType, CommonOrderType> = {
  [TvOrderType.M]: 'M',
  [TvOrderType.SL]: 'SLL',
  [TvOrderType.SLM]: 'SLM',
  [TvOrderType.L]: 'L',
};

export enum OrderRequestMode {
  BASKET = 'BASKET',
  STRATEGY = 'STRATEGY',
  REGULAR = 'REGULAR',
}

export enum OrderCategory {
  REGULAR = 'REGULAR',
  CONDITIONAL = 'CONDITIONAL',
  CO = 'CO',
  OCO = 'OCO',
  CONDITIONAL_HOLDINGS = 'CONDITIONAL_HOLDINGS',
}

export enum CommonOrderSide {
  B = 'BUY',
  S = 'SELL'
}

export enum CommonOrderValidity {
  D = 'DAY',
  I = 'IOC'
}

export const SEGMENT_TO_DISPLAY_NAME_MAP: {
  [key in SegmentType]?: string
} = {
  [SegmentType.NSE_EQ]: 'NSE',
  [SegmentType.BSE_EQ]: 'BSE',
  [SegmentType.NSE_FO]: 'NFO',
  [SegmentType.BSE_FO]: 'BFO',
  [SegmentType.NCD_FO]: 'NCD',
  [SegmentType.BCD_FO]: 'BCD',
  [SegmentType.MCX_FO]: 'MCX',
  [SegmentType.NSE_INDEX]: 'NSE',
  [SegmentType.BSE_INDEX]: 'BSE',
  [SegmentType.MCX_INDEX]: 'MCX',
  [SegmentType.MCX_COM]: 'MCX',
};
